module.exports = __webpack_public_path__ + "media/level_center_talk.fa09d4df.mp3";